import React from 'react';

function Nightowl({ navigateTo, userSettings, fleetSettings }) {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Nightowl Service</h2>
      <p>This feature is coming soon...</p>
      <button 
        onClick={() => navigateTo('dashboard')}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Back to Dashboard
      </button>
    </div>
  );
}

export default Nightowl;
